import React from 'react';
import { EyeIcon } from 'lucide-react';
export function GallerySection() {
  const images = ['https://cdn.magicpatterns.com/uploads/1FbZRBaJzbjGmi4zydytPx/IMG_1550-1--1920w.webp', 'https://cdn.magicpatterns.com/uploads/nJ1Vx7Qju5Z5RdgdTnj8b1/IMG_3825-1--1920w.webp', 'https://cdn.magicpatterns.com/uploads/6LXwWLa8BYbZ3d9bmazw1X/20230413_183151-1--1920w.webp'];
  return <section id="gallery" className="bg-white py-16 md:py-28" data-id="element-97">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-98">
        <div className="text-center mb-10 sm:mb-16" data-id="element-99">
          <span className="block text-gold font-semibold tracking-widest text-sm uppercase mb-4" data-id="element-100">
            Our Work
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-charcoal" data-id="element-101">
            See the Difference
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mb-10 sm:mb-12" data-id="element-102">
          {images.map((src, index) => <div key={index} className="relative overflow-hidden rounded-xl group cursor-pointer bg-gray-100 aspect-[4/3]" data-id="element-103">
              <img src={src} alt={`Gallery installation ${index + 1}`} className="w-full h-full object-cover" data-id="element-104" />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-105">
                <EyeIcon className="w-10 h-10 text-white" data-id="element-106" />
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-107">
          <a href="#gallery" className="inline-flex items-center gap-2 text-gold hover:text-gold-hover font-bold text-lg transition-colors" data-id="element-108">
            View Full Gallery →
          </a>
        </div>
      </div>
    </section>;
}